import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const FEATURES = [
  {
    id: 'review',
    title: '네이버 카카오 리뷰 연동',
    desc: '주문 완료 후 자동으로 리뷰 작성 화면으로 연결. 리뷰가 쌓이면 신규 손님이 늘어납니다.',
    hasCustomIcon: true,
  },
  {
    id: 'language',
    icon: 'solar:globe-bold',
    color: '#3B82F6',
    title: '다국어 자동 지원',
    desc: '영어, 중국어, 일본어 메뉴가 자동 제공. 외국인 손님도 쉽게 주문합니다.',
    badges: ['KO', 'EN', 'CN', 'JP'],
  },
  {
    id: 'menu',
    icon: 'solar:document-add-bold',
    color: '#10B981',
    title: '간편 메뉴 관리',
    desc: '메뉴 추가, 가격 변경, 품절 처리를 관리자 앱에서 언제 어디서나 실시간 반영.',
  },
  {
    id: 'table',
    icon: 'solar:widget-bold',
    color: '#8B5CF6',
    title: '테이블 현황 관리',
    desc: '어떤 테이블에서 무엇을 주문했는지 실시간으로 한눈에 파악합니다.',
  },
  {
    id: 'security',
    icon: 'solar:shield-check-bold',
    color: '#F59E0B',
    title: '큐싱 방지 보안 QR',
    desc: 'URL이 외부에 노출되지 않아 QR 피싱(큐싱)을 원천 차단. 안심 주문.',
  },
  {
    id: 'ui',
    icon: 'solar:pallete-2-bold',
    color: '#FDCD27',
    title: '업계 최고 깔끔한 UI',
    desc: '어떤 테이블오더보다 직관적이고 깔끔한 주문 화면. 고객이 헤매지 않습니다.',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-28 lg:py-40 bg-neutral-950 text-white relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-brand-400/4 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <RevealWrap className="text-center max-w-2xl mx-auto mb-20">
          <p className="text-brand-400 font-semibold text-sm tracking-wide uppercase mb-3">Features</p>
          <h2 className="text-3xl lg:text-5xl font-bold leading-snug tracking-tight mb-5">
            매장 운영의 모든 것,<br />하나로 통합합니다
          </h2>
          <p className="text-neutral-400 text-lg leading-relaxed">
            주문부터 리뷰 관리까지, 와우오더 하나면 충분합니다.
          </p>
        </RevealWrap>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => (
            <RevealWrap key={f.id} animation="scale" className={`reveal-delay-${(i % 3) + 1}`}>
              <div className="group h-full rounded-2xl bg-white/[0.04] border border-white/[0.08] p-8 hover:bg-white/[0.07] transition-all duration-500">
                {f.hasCustomIcon ? (
                  <div className="flex items-center gap-2 mb-6">
                    <img src="/landing/naver-icon.svg" alt="네이버" width={36} height={36} className="rounded-lg" />
                    <img src="/landing/kakao-icon.svg" alt="카카오" width={36} height={36} className="rounded-lg" />
                  </div>
                ) : f.badges ? (
                  <div className="flex gap-2 mb-6">
                    {f.badges.map((l, j) => (
                      <span
                        key={l}
                        className={`w-9 h-9 rounded-lg flex items-center justify-center text-xs font-bold ${
                          j === 0 ? 'bg-blue-500/20 text-blue-400' : 'bg-white/10 text-neutral-300'
                        }`}
                      >
                        {l}
                      </span>
                    ))}
                  </div>
                ) : (
                  <div
                    className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500"
                    style={{ backgroundColor: `${f.color}15` }}
                  >
                    <Icon icon={f.icon} width={28} height={28} style={{ color: f.color }} />
                  </div>
                )}

                <h3 className="text-xl font-bold text-white mb-3 leading-snug">{f.title}</h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{f.desc}</p>
              </div>
            </RevealWrap>
          ))}
        </div>
      </div>
    </section>
  );
}
